import { render } from "./SamplesPage.vue?vue&type=template&id=69a005aa&scoped=true"
import script from "./SamplesPage.vue?vue&type=script&lang=js"
export * from "./SamplesPage.vue?vue&type=script&lang=js"

import "./SamplesPage.vue?vue&type=style&index=0&id=69a005aa&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a005aa"]])

export default __exports__